import { cart, settings, user } from 'core';
import { Carousel } from 'ui/components/compounds';

import ProductListCard from '../../Products/components/ProductCardList/ProductListCard';
import { TProductsCarousel } from '../../Products/components/ProductList/ProductList';
import { ProductsComponents } from '../../Products/components/Products.components.styles';

const ProductsCarousel = ({ data, isMobile }: TProductsCarousel) => {
  const { addItem, updateItem } = cart.commands.useCartCommand();
  const isBuyIntentionFeatureActive = settings.hooks.useFeatureToggle('buyIntention');
  const { setBuyIntention } = user.commands.useUserCommand();
  const { isBuyIntention } = user.hooks.useIsBuyIntention();
  const isResaleIntention = user.selectors.useIsResaleIntention();
  const isAutoStartEnabled = user.selectors.useIsAutoStartEnabled();
  return (
    <ProductsComponents.WrapperCarousel>
      <Carousel.Container
        container={true}
        desktop={!isMobile}
        dots
        itemsPerPage={{ desktop: isMobile ? 2 : 4, mobile: 2 }}
        navigationSize={isMobile ? 'sm' : 'lg'}
      >
        {data.map((cardData) => (
          <Carousel.Slide
            key={`carousel-${cardData.productCode}`}
            customProps={{ 'data-product-list': true }}
          >
            <ProductListCard
              key={`productCard-${cardData.productCode}`}
              cardData={cardData}
              addItem={addItem}
              updateItem={updateItem}
              isBuyIntentionFeatureActive={isBuyIntentionFeatureActive}
              isBuyIntention={isBuyIntention}
              setBuyIntention={setBuyIntention}
              isResaleIntention={isResaleIntention}
              isAutoStartEnabled={isAutoStartEnabled}
            />
          </Carousel.Slide>
        ))}
      </Carousel.Container>
    </ProductsComponents.WrapperCarousel>
  );
};

export default ProductsCarousel;
